'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import VideoComponent, { Video } from './video';

interface VimeoContentProps {
    videos: Video[];
}

const SORT_OPTIONS = [
    { value: 'date', label: 'byDate' },
    { value: 'az', label: 'az' },
    { value: 'za', label: 'za' },
];

const VimeoContent = (props: VimeoContentProps) => {
    const { videos } = props;
    const t = useTranslations();
    const [sortedVideos, setSortedVideos] = useState<Video[]>(videos);
    const [sortOption, setSortOption] = useState<string>('date');

    const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOption = event.target.value;
        setSortOption(selectedOption);

        const sorted = [...videos].sort((a, b) => {
            if (selectedOption === 'date') {
                return new Date(b.created_time).getTime() - new Date(a.created_time).getTime();
            } else if (selectedOption === 'az') {
                return a.name.localeCompare(b.name);
            } else if (selectedOption === 'za') {
                return b.name.localeCompare(a.name);
            }
            return 0;
        });

        setSortedVideos(sorted);
    };
    return (
        <section className="w-screen px-4 md:px-10 py-20 bg-bg-200">
            <header className="flex justify-end">
                <div className="relative flex gap-5 items-center">
                    <label
                        htmlFor="sort"
                        className="font-helveticaNeue font-light block text-xl text-black/50 text-nowrap"
                    >
                        {t('Explore.sort.title')}
                    </label>
                    <select
                        id="sort"
                        value={sortOption}
                        onChange={handleSortChange}
                        className="md:mt-1 block w-full text-2xl border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-smbg-none bg-transparent border-b rounded-none uppercase"
                    >
                        {SORT_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {t(`Explore.sort.${option.label}`)}
                            </option>
                        ))}
                    </select>
                </div>
            </header>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-10">
                {sortedVideos.map((video) => (
                    <VideoComponent key={video.uri} video={video} />
                ))}
            </div>
        </section>
    );
};

export default VimeoContent;
